import Vue from 'vue'
import App from './App.vue'
import store from './store';


import './filters.js';

Vue.config.productionTip = false

import moment from "moment";
import VueMomentJS from "vue-momentjs";
Vue.use(VueMomentJS, moment);

window.axios = require('axios');
export const EventBus = new Vue();

new Vue({
  store,
  render: h => h(App),
}).$mount('#bed-builder')
